// extracted by mini-css-extract-plugin
module.exports = {"modal_content_grid":"ChangeCompanyModal_modal_content_grid__UdJVG","row":"ChangeCompanyModal_row__1Qer2"};